import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export function useLocationMatcher(pathname: string) {
  const location = useLocation();
  return useMemo(() => location.pathname === pathname, [location.pathname]);
}
